import { createClient, type SupabaseClient } from "@supabase/supabase-js";

import type { Database } from "@/types/database";

function requireEnv(value: string | undefined, name: string): string {
  const resolved =
    value ?? (typeof process !== "undefined" ? process.env[name] : undefined);
  if (!resolved) {
    throw new Error(
      `Missing environment variable: ${name}. Add it to your .env file (see .env.example).`,
    );
  }
  return resolved;
}

const supabaseUrl = requireEnv(import.meta.env.VITE_SUPABASE_URL, "VITE_SUPABASE_URL");
const supabaseAnonKey = requireEnv(
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  "VITE_SUPABASE_ANON_KEY",
);

export const supabase: SupabaseClient<Database> = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      detectSessionInUrl: true,
      flowType: "pkce",
      persistSession: true,
    },
  },
);
